import MaterialTable from '@material-table/core';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { mapTableOptions } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import tableColumns from './tableColumns';
import Optional from '../../../utils/optional';
import { isArrayEmpty } from '../../../utils/isDefined';
import Features from './Features';
import History from './History';

const Table = ({
  data,
  lang,
  selectedAccount,
  selectOptions,
  historyView,
  clientId
}) => {
  const { localization } = useTableLocalization();

  const tableDefaultColumns = useMemo(() => {
    return tableColumns({
      lang,
      selectedAccount,
      selectOptions,
      historyView,
      clientId
    });
  }, [lang, selectedAccount, selectOptions, historyView]);

  const options = useMemo(() => {
    return {
      ...mapTableOptions({ exportData: false }),
      search: false,
      selection: false,
      columnsButton: false,
      showTitle: false,
      toolbar: false,
      paging: data.length < 25 ? false : true,
      maxBodyHeight: '100vh',
      padding: 'default',
      toolbarButtonAlignment: 'left'
    };
  }, [data]);

  const detailPanel = useMemo(
    () => [
      rowData => ({
        disabled: isArrayEmpty(rowData.projection),
        icon: () => (
          <i
            className="fas fa-chevron-right"
            style={{
              display: isArrayEmpty(rowData.projection) ? 'none' : '',
              fontSize: '12px'
            }}
          ></i>
        ),
        openIcon: () => (
          <i
            className="fas fa-chevron-down"
            style={{
              fontSize: '12px'
            }}
          ></i>
        ),
        render: () => <Features subReference={rowData.externalReference} />
      }),
      rowData => ({
        icon: () => (
          <i
            className="far fa-history"
            style={{
              fontSize: '16px',
              fontWeight: 800
            }}
          ></i>
        ),
        openIcon: () => (
          <i
            className="far fa-history"
            style={{
              fontSize: '16px',
              fontWeight: 800,
              transform: 'rotate(-90deg)'
            }}
          ></i>
        ),
        render: () => <History data={rowData.all} />
      })
    ],
    []
  );

  return (
    <MaterialTable
      columns={tableDefaultColumns}
      data={data}
      options={options}
      localization={localization}
      detailPanel={!historyView ? detailPanel : null}
    />
  );
};

const mapStatesToProps = ({ subscriptionsImproved, auth, selectClient }) => {
  const { selectedAccount, selectOptions } = subscriptionsImproved;
  return {
    lang: Optional(auth.lang).or('default'),
    selectedAccount,
    selectOptions,
    clientId: Optional(selectClient.selectedClient?.id).or(void 0)
  };
};

export default connect(mapStatesToProps)(Table);
